import React from 'react'
import { useTranslation } from 'react-i18next';
import SettingsIcon from "../Assets/icons/setting_icon.png"
import ProfileIcon from "../Assets/icons/user_icon.png"
import PasswordIcon from "../Assets/icons/password_icon.png"
import ModulesIcon from "../Assets/icons/modules_icons.png"
import ActivityIcon from "../Assets/icons/activity_icons.png"
function MenuItem({ setActiveItem, activeItem }) {
    const { t } = useTranslation();
    var items = [
        {
            key: 'profile',
            label: t('settings.menu.profile'),
            img: ProfileIcon
        },
        {
            key: 'password',
            label: t('settings.menu.password'),
            img: PasswordIcon
        },
        {
            key: 'modules',
            label: t('settings.menu.modules'),
            img: ModulesIcon
        },
        {
            label: t('settings.menu.activity'),
            key: "activity",
            img: ActivityIcon
        }
    ]

    var ItemStyle = (item) => {
        var onClick = () => {
            setActiveItem(item.key)
        }
        return <div kye={item.key}
            className={activeItem === item.key ? "menu-item-element menu-item-element-selected" : "menu-item-element"}
            onClick={onClick}>
            <img src={item.img} /> {item.label}
        </div>
    }
    return (
        <div className='settings-item-layout'>
            <div className='menu-title'>
                <img src={SettingsIcon} /> <span>{t('settings.title')}</span>
            </div>

            {items.map((item) => ItemStyle(item))}
        </div>
    )
}

export default MenuItem
